import React from 'react';

import { BaseStopRecordingButton } from '../../toolbar-buttons/base-stop-recording-button';

export function StopCloudRecordingButton() {
    return <BaseStopRecordingButton recordingPlace="cloud" />;
}
